import { render, staticRenderFns } from "./ConsentimentoCookies.vue?vue&type=template&id=2d7bc61c&scoped=true"
import script from "./ConsentimentoCookies.vue?vue&type=script&lang=js"
export * from "./ConsentimentoCookies.vue?vue&type=script&lang=js"
import style0 from "./ConsentimentoCookies.vue?vue&type=style&index=0&id=2d7bc61c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7bc61c",
  null
  
)

export default component.exports